import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { BARCODE_LENGTH } from "src/app/common/Const";

@Component({
  selector: 'app-barcode-button',
  templateUrl: './barcode-button.component.html',
  styleUrls: ['./barcode-button.component.css']
})
export class BarcodeButtonComponent implements OnInit {

  private focused: boolean = false;
  private barcode: string = "";

  @ViewChild('barcodeInput') barcodeInput!: ElementRef<HTMLInputElement>;

  @Output("onScan") onScan: EventEmitter<string> = new EventEmitter();
  @Output("onFocus") onFocus: EventEmitter<any> = new EventEmitter();
  @Output("onBlur") onBlur: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  @HostListener('window:keyup', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (!this.focused) return;

    event.preventDefault();

    if (event.key === "Enter" || event.code === "Enter") {
      if (this.barcode.trim() !== "") {
        this.onScan.emit(this.barcode);
      }
      this.barcode = "";
      return;
    }

    // Handle Backspace 
    if (event.key === "Backspace") {
      event.preventDefault(); // prevent browser from doing it twice if needed
      this.barcode = this.barcode.slice(0, -1); // remove last char
      return;
    }

    // only allow numeric input
    if (!/^[0-9]$/.test(event.key) || event.ctrlKey || event.metaKey || event.altKey || event.key.length > 1 || event.code === "Backquote") {
      return;
    }
    
    // ✅ Append digit if less than BARCODE_LENGTH digits
    if (this.barcode.length < BARCODE_LENGTH) {
      this.barcode += event.key;
    }
  }

  forcusIn() {
    this.focused = true;
    this.onFocus.emit();
  }

  forcusOut() {
    this.focused = false;
    this.barcode = "";
    this.onBlur.emit();
  }

  focusInput() {
    this.focused = true;
    this.barcode = "";
    this.barcodeInput.nativeElement.focus();
  }
}
